import {directDownload} from '@/utils/download-helper';
import Axios from 'axios';
import {ActionTree} from 'vuex';
import {RootState} from '../../types';
import {
    ActionUserItem,
    DetailFilterParams,
    ActionUsersState,
    PartnerUsersPagesItem
} from './types';
import axios from "axios";

export const actions: ActionTree<ActionUsersState, RootState> = {
    getActionUsers: ({commit}, data) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Axios({url: '/acapi/users/action_logs', params: data})
                .then(resp => {
                    if (data.page_number > 1) {
                        commit("pushActionUsers", resp.data.actions);
                    } else {
                        commit('setActionUsers', resp.data.actions);
                    }
                    resolve(resp)
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false));
        })
    },
    getActionUserItem: ({commit}, id) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: `/acapi/users/action_logs/${id}`})
                .then((resp: any) => {
                    let actionUserItem = <ActionUserItem>resp.data;
                    actionUserItem.id = id;
                    commit('setActionUserItem', resp.data);
                    resolve(actionUserItem)
                })
                .catch(err => {
                    reject(err)
                }).finally(() => commit('setLoading', false));
        })
    },
    saveActionUserItem: ({commit, dispatch}, data: ActionUserItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Axios({
                method: data.id ? 'put' : 'post',
                url: '/acapi/system_users/actions/' + (data.id ?? ''),
                data: data
            })
                .then((resp: any) => {
                    dispatch('getActionUsers');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                }).finally(() => commit('setLoading', false));
        })
    },
    deleteActionUserItem: ({commit, dispatch}, data: ActionUserItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            Axios({
                method: 'delete',
                url: `/acapi/system_users/actions/${data.id}`,
                data: data
            })
                .then((resp: any) => {
                    dispatch('getActionUsers');
                    resolve(resp)
                })
                .catch((err: any) => {
                    reject(err)
                }).finally(() => commit('setLoading', false));
        })
    },
    exportActionUsers({}, data: DetailFilterParams) {
        return directDownload('/acapi/users/action_logs/export', data)
    },
    getObjectTypes: ({commit}, data) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: '/acapi/users/object_types', params: data})
                .then(resp => {
                    commit('setObjectTypes', resp.data.object_types);
                    resolve(resp?.data ?? [])
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    },
    getPartnerUsersPages: ({commit}, data: PartnerUsersPagesItem) => {
        commit('setLoading', true);
        return new Promise((resolve, reject) => {
            axios({url: '/acapi/partner_users/pages', params: data})
                .then(resp => {
                    commit('setPartnerUsersPages', resp.data.pages);
                    resolve(resp?.data ?? [])
                })
                .catch(err => {
                    reject(err)
                })
                .finally(() => commit('setLoading', false))
        })
    }
};
